// config.js
// Keep your existing imports
import { materialManager } from "./materialManager"

export const defaultRivestimento = {
  slug: "",
  name: "",
  thumbnail: "",
}

export const defaultStruttura = {
  slug: "",
  name: "",
  thumbnail: "",
}

export const defaultFinitura = {
  slug: "",
  name: "",
  thumbnail: "",
}

// Global configuration if needed
export let configuration = {
  rivestimento: defaultRivestimento.slug,
}

// Queue for processing material changes sequentially
const materialChangeQueue = []
let isProcessingQueue = false

// Clear the material change queue (call when switching products to prevent stale operations)
export function clearMaterialQueue() {
  materialChangeQueue.length = 0
  isProcessingQueue = false
}

// Process the next item in the queue
function processNextInQueue() {
  if (materialChangeQueue.length === 0) {
    isProcessingQueue = false
    return
  }

  isProcessingQueue = true
  const nextOperation = materialChangeQueue.shift()

  try {
    applyMaterialChange(
      nextOperation.materialVariation,
      nextOperation.configurableMaterial,
      nextOperation.delay,
      () => {
        // Success callback - proceed to next item after a small delay
        setTimeout(() => {
          processNextInQueue()
        }, 150) // Slightly longer delay between operations
      }
    )
  } catch (error) {
    console.error("Error processing queue item:", error)
    // Continue with next item even if one fails, after a delay
    setTimeout(() => {
      processNextInQueue()
    }, 150)
  }
}

// Function to apply a single material change without using Promises
function applyMaterialChange(
  materialVariation,
  configurableMaterial,
  delay = 50,
  onComplete = null
) {
  if (!window.emViewers || !window.emViewers["emersyaIframe"]) {
    console.error("emersyaIframe not found")
    if (onComplete) onComplete()
    return
  }

  setTimeout(() => {
    try {
      /*  console.log(
        `Applying material: ${materialVariation} to ${configurableMaterial}`
      ) */

      // Call setMaterials without assuming Promise support
      window.emViewers["emersyaIframe"].setMaterials({
        materials: [
          {
            materialVariation: materialVariation,
            configurableMaterial: configurableMaterial,
          },
        ],
      })

      // Wait a bit to ensure the operation completes before reporting success
      setTimeout(() => {
        /*   console.log(
          `Material applied successfully: ${materialVariation} to ${configurableMaterial}`
        ) */
        if (onComplete) onComplete()
      }, 100)
    } catch (error) {
      console.error("Error applying material:", error)
      if (onComplete) onComplete()
    }
  }, delay)
}

// Improved switchConfiguration function that uses the queue
export function switchConfiguration(configurationName, type, delay = 0) {
  /* console.log("=== SWITCH CONFIGURATION ===")
  console.log("Material obj:", {
    collection: configurationName.collection || "",
    name: configurationName.name,
    optional: configurationName.optional || false,
    slug: configurationName.slug,
    standard: configurationName.standard || false,
    thumbnail: configurationName.thumbnail,
    viewerName: configurationName.viewerName,
  })
  console.log("Type:", type) */

  // For safety, use the getTechnicalName if needed
  const technicalName = type

  // Check if the emersyaIframe exists
  if (window.emViewers && window.emViewers["emersyaIframe"]) {
    // Get the material name to apply
    const materialToApply =
      configurationName.viewerName || configurationName.name

    // Add to queue with specified delay
    materialChangeQueue.push({
      materialVariation: materialToApply,
      configurableMaterial: technicalName,
      delay: delay,
    })

    /*  console.log(
      `Configuration of ${materialToApply} for ${technicalName} added to queue`
    )
 */
    // Start processing the queue if not already processing
    if (!isProcessingQueue) {
      processNextInQueue()
    }
  } else {
    console.error("emersyaIframe not found")
  }

  /* console.log("=== END SWITCH CONFIGURATION ===") */
}

// Function to apply the old setMaterial method directly without queue (for backwards compatibility)
export function setMaterialWithDelay(
  materialVariation,
  configurableMaterial,
  delay = 50
) {
  if (!window.emViewers || !window.emViewers["emersyaIframe"]) {
    console.error("emersyaIframe not found")
    return
  }

  setTimeout(() => {
    try {
      window.emViewers["emersyaIframe"].setMaterials({
        materials: [
          {
            materialVariation: materialVariation,
            configurableMaterial: configurableMaterial,
          },
        ],
      })
      /*   console.log(
        `Material applied: ${materialVariation} to ${configurableMaterial} after ${delay}ms delay`
      ) */
    } catch (error) {
      console.error("Error applying material:", error)
    }
  }, delay)
}

// Helper function for applying linked materials with sequential timing
export function applyLinkedMaterials(materialObj, types) {
  if (!types || types.length === 0) return

  // Clear the existing queue to prevent conflicts
  materialChangeQueue.length = 0
  isProcessingQueue = false

  // Add all types to the queue with progressive delays
  types.forEach((type, index) => {
    // First item gets 0 delay, subsequent items get increasing delays
    const delay = index * 400 // Significantly increased delay (400ms per item)
    switchConfiguration(materialObj, type, delay)
  })
}
